import React from "react";
import Box from "@mui/material/Box";
import Progress from "../Progress";
import RaceMode from "./RaceMode";

export default function Footer({ step, steps = 3, startTime, completeTime, children, showRaceMode = true }) {
  return (
    <Box>
      <Progress step={step} steps={steps} />
      <Box px={2} py={1.5} display="flex" justifyContent="space-between" alignItems="center">
        {showRaceMode ? <RaceMode startTime={startTime} completeTime={completeTime} /> : <Box />}
        {children}
      </Box>
    </Box>
  );
}
